type Props = { colorClass: string };

export function FarmHouse({ colorClass }: Props) {
  return (
    <svg viewBox="0 0 100 100" className={`w-full h-full ${colorClass} drop-shadow-md`}>
      <path
        d="M20 90 L20 40 L50 15 L80 40 L80 90 Z"
        fill="currentColor"
        stroke="#555"
        strokeWidth={3}
      />
      <rect x="35" y="55" width="30" height="35" fill="#8B4513" />
      <path d="M50 25 L50 35" stroke="#FFF" strokeWidth={3} opacity={0.5} />
      <circle cx="50" cy="30" r="4" fill="#FFF" opacity={0.8} />
    </svg>
  );
}
